/** 数字展示格式化：1000 -> 1千，10000 -> 1万，123456 -> 12.3万 */
export function formatNum(n: number): string {
  if (n >= 10000) {
    const w = n / 10000;
    return `${w >= 100 ? Math.round(w) : Number(w.toFixed(1))}万`;
  }
  if (n >= 1000) {
    const k = n / 1000;
    return `${Number(k.toFixed(1))}千`;
  }
  return String(n);
}